<template>
    <div>
        <div class="btn-instruction" @click="modal_show = true">
            <i class="fa fa-info"></i>
            {{ instr_content.title }}
        </div>


        <!-- Modal: Show Log Detail -->
        <b-modal scrollable size="lg" ref="modal"
                v-model="modal_show"
                header-bg-variant="primary"
                hide-header-close hide-footer>

            <!-- header -->
            <div slot="modal-header">
                <i class="fa fa-graduation-cap"></i>{{ $t('menu.little_doctor_agri') }}
            </div>

            <!-- body -->
            <div>
                <b-row class="justify-content-center">

                    <b-col md=11>
                        <div class="instruction-title">{{ instr_content.title }}</div>
                        <div class="instruction-context">
                            {{ instr_content.content[0] }}
                        </div>
                        <div class="instruction-context">
                            {{ instr_content.content[1] }}
                        </div>
                        <div class="instruction-context">
                            {{ instr_content.content[2] }}
                        </div>
                    </b-col>

                    <b-col md="8">
                        <div class="instruction-img">
                            <b-img :src="$config.getAssetsURL('img/instr/report_instructions_EC_residual_1.png')" fluid alt="report_instructions_EC_residual_1" />
                        </div>
                        <div class="instruction-img">
                            <b-img :src="$config.getAssetsURL('img/instr/report_instructions_EC_residual_2.png')" fluid alt="report_instructions_EC_residual_2" />
                        </div>
                    </b-col>

                </b-row>

            </div>

            <!-- footer -->
            <div class="modal-footer-block text-center">

                <b-button variant="secondary" class="btn btn-upload"
                        @click.prevent="modal_show = false">
                    <i class="fa fa-close"></i> {{ $t('menu.close') }}
                </b-button>

            </div>

        </b-modal>




    </div>
</template>

<script>
import { mapState }     from 'vuex'

export default {
    data () {
        return {
            // modal
            modal_show: false,
        }
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

        instr_content ()
        {
            if ( this.language == 'zh-Hant-TW' )
            {
                return {
                    title: '土壤電導度殘差圖怎麼看 ?',
                    content: [
                        '感測器回傳之土壤含水量及土壤電導度具高度正相關。',
                        '為盡可能排除土壤含水量對電導度的影響，以實際觀察土壤電導度長期增減趨勢，我們利用回歸模型計算出土壤含水量對電導度的影響，將土壤電導度實際測值扣除土壤含水量的效應後，將所獲得的殘差值作圖，以更精確地呈現土壤中離子的狀態。',
                        '若殘差圖趨勢為向下或負值較多，可判定土壤中離子在流失狀態。',
                    ],
                }
            }
            else
            {
                return {
                    title: 'Residual Plot of soil EC value ?',
                    content: [
                        'The correlation between soil moisture and soil EC value is highly positive.',
                        'To remove the effect of soil moisture to soil EC value for observing the actual trend of soil EC value, we use regression analysis to calculate the effect of soil moisture and remove it. The residual result is shown in the chart and reveals the status of the ion more accurately. ',
                        'If the trend of residual goes down or the most values are negative, we can conclude that the icon in the soil is losing.',
                    ],
                }
            }
        },

    },
}
</script>

<style lang="scss" scoped>

.modal-footer-block
{
    margin: 15px 0px;
}

</style>
